<template>
  <section class="postingan">
    <div style="margin: 5em 0;min-height: 100vh;">
      <div class="container">

        <div class="card" v-for="(row, i) in postingan" :key="`postingan-${i}`">
          <div class="card-body">
            <h4>
              <Link v-text="row.title" :href="`/${prefix}/${row.slug}`"></Link>
            </h4>
            <p class="text-muted">
              <span v-text="(new Date(row.created_at)).toLocaleString()"></span>
            </p>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import layout from '@/layout/Portal'
export default {
  layout,
  props: {
    postingan: String,
    prefix: String,
  }
}
</script>